import React, {useState, useEffect} from "react";
import Tabs from "@common/Tabs";
import Tab from "@common/Tab";
import MyClasses from "./MyClasses";
import "../../webapp/users/dashboard/js/teacherCompetitions.js";
import AllClasses from "./AllClasses";
import SchoolAdmins from "./SchoolAdmins";
import ClassDetails from "./ClassDetails";
import {AdminIcon} from "@common/icons";
import {List, Circle} from "@mui/icons-material";

const MyClassesTabs = props => {
    const TABS = {
        MY_CLASSES: {val: 0, hash: 'myClasses'},
        ALL_CLASSES: {val: 1, hash: 'allClasses'},
        SCHOOL_ADMINS: {val: 2, hash: 'schoolAdmins'},
        CLASS: {val: 3, hash: 'class'}
    }
    const [activeTabKey, setActiveTabKey] = useState(TABS.MY_CLASSES.val);
    const [activeClass, setActiveClass] = useState({});

    const handleChangeTab = (key) => {
        setActiveTabKey(key);
    };

    useEffect(() => {
        if (activeClass.classId) setActiveTabKey(TABS.CLASS.val);
    }, [activeClass]);

    return (
        <Tabs activeKey={activeTabKey} variant="standard" onChange={handleChangeTab} contentClassName="margin-t--l" destroyOnHidden={true}>
            <Tab tab={<>
                <List className={'margin-r--m'}/>
                <span className={'margin-r--m tabText'}>My Classes</span>
            </>} key={TABS.MY_CLASSES.val} hash={TABS.MY_CLASSES.hash} children={
                <MyClasses updateActiveClass={(classId) => setActiveClass(classId)} loadAllClasses={() => setActiveTabKey(TABS.ALL_CLASSES.val)} />
            }/>
            <Tab tab={<>
                <List className={'margin-r--m'}/>
                <span className={'margin-r--m tabText'}>All Classes</span>
            </>} key={TABS.ALL_CLASSES.val} hash={TABS.ALL_CLASSES.hash} children={
                <AllClasses updateActiveClass={(classId) => setActiveClass(classId)} />
            }/>
            <Tab tab={<>
                <AdminIcon className={'margin-r--m'}/>
                <span className={'margin-r--m tabText'}>School Administrators</span>
            </>} key={TABS.SCHOOL_ADMINS.val} hash={TABS.SCHOOL_ADMINS.hash} children={
                <SchoolAdmins />
            }/>
            {(activeClass && activeClass.classId) && (
                <Tab tab={<>
                    <Circle className={'margin-r--m'} style={{width:'20px', height:'20px'}}/>
                    <span className={'margin-r--m tabText'}>{activeClass.className}</span>
                </>} key={TABS.CLASS.val} hash={TABS.CLASS.hash} children={
                    <ClassDetails classId={activeClass.classId} />
                }/>
            )}
        </Tabs>
    );
}

export default MyClassesTabs;